// eslint-disable-next-line import/prefer-default-export
export const Routes = {
  DASHBOARD: {
    path: '/',
    paths: ['/dashboard', '/usps-emails', '', '/'],
    name: 'dashboard'
  },
  WORKFLOW: {
    path: '/workflow',
    name: 'workflow-list'
  },
  WORKFLOW_EDIT: {
    path: '/workflow/edit', // '/workflow/edit/:uuid'
    name: 'workflow-edit'
  },
  TEMPLATE: {
    path: '/template',
    name: 'template-customize'
  },
  TEAM: {
    path: '/team',
    name: 'team-view'
  },
  PROFILE: {
    path: '/user/profile',
    name: 'user-profile'
  },
  COMPANY: {
    path: '/company',
    name: 'company'
  },
  COMPANIES: {
    path: '/companies',
    name: 'companies'
  },
  LOCATION_ADD: {
    path: '/location-add',
    name: 'location-add'
  },
  LIEN_SUMMARY: {
    name: 'lien-summary',
    path: '/lien-summary'
  },
  REPORTS: {
    path: '/reports',
    name: 'reports'
  },
  DocUpload: {
    path: '/doc-upload',
    name: 'doc-upload'
  }
};
